import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import MetaTags from 'react-meta-tags';
import Prismic from 'prismic-javascript';
import { Link } from 'react-router-dom';

import Header from '../../components/header';
import Newsletter from '../../components/newsletter';
import Footer from '../../components/footer';
import Breadcrumbs from '../../components/breadcrumbs';
import BarWhereFind from '../../components/bar-where-find';

import LanguageContext from '../../context/LangContext';

const Container = styled.div`
  background: #DEDEDE;
  padding: 48px 0 92px;
  .wrapper {
    .flex {
      align-items: flex-start;
      justify-content: space-between;
      display: flex;

      @media (max-width: 900px) {
        flex-wrap: wrap;
        aside,
        article {
          max-width: 100%;
          width: 100%;
          margin-left: 0;
        }
        aside {
          margin-top: 80px;
        }
      }
    
      @media (max-width: 540px) {
        flex-wrap: wrap;
      }
    }
    article {
      width: 100%;
      max-width: 50%;
    }
    aside {
      width: 450px;
      margin-left: 100px;
    }
  }
`

const Title = styled.div`
  font: italic bold 46px 'Times new roman';
  margin: 0 0 72px;
`

const Filter = styled.div`
  margin: 56px 0 0;
  display: flex;

  @media (max-width: 540px) {
    flex-wrap: wrap;
  }

  select {
    width: 50%;
    margin-left: 16px;
    background: none;
    height: 60px;
    border: 0;
    border-bottom: 2px solid #979797;
    font: italic bold 20px 'Times new roman';
    color: #000;

    &:first-child {
      margin-left: 0;
    }

    @media (max-width: 540px) {
      width: 100%;
      margin-left: 0;
      margin-top: 10px;
    }
  }
`

const Items = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 70px;

  .item {
    margin: 0 0 16px 16px;
    background: #fff;
    padding: 20px 26px;
    color: #000;
    width: calc(50% - 8px);
    box-sizing: border-box;
    font-size: 16px;

    &:first-child {
      margin-left: 0;
    }

    &:nth-child(2n+1) {
      margin-left: 0;
    }

    .title {
      font: italic bold 30px 'Times new roman';
    }

    @media (max-width: 789px) {
      width: 100%;
      margin-left: 0;
    }
  }
`

const apiEndpoint = 'https://guararapes.cdn.prismic.io/api/v2'
const Client = Prismic.client(apiEndpoint);

class OndeEncontrarRepresentantes extends Component {
  state = {
    seo: {},
    cidades: [],
    estados: [],
    selectedCity: '',
    selectedUF: '',
  }

  componentDidMount = () => {
    window.scrollTo(0, 0)
    const fetchDataSeo = async () => {
      const response = await Client.query(
        Prismic.Predicates.at('document.type', 'onde_encontrar')
      )
      if (response.results[0]) {
        this.setState({seo: response.results[0].data});
      }
    }
    fetchDataSeo();

    this.getRepresentants();
  }

  componentDidUpdate = () => {
    const { language } = this.context;
    if (language !== 'pt-br')
      this.props.history.push('/onde-encontrar/compensados');
  }

  getRepresentants = () => {
    const fetchData = async () => {
      const response = await Client.query(
        Prismic.Predicates.at('document.type', 'representantes'),
      )
      if (response) {
        const cidades = []
        const estados = []
        response.results.map((item) => {
          if (cidades.indexOf(item.data.cidade) < 0)
            cidades.push(item.data.cidade)
          if (estados.indexOf(item.data.estado_uf) < 0)
            estados.push(item.data.estado_uf)
          return true;
        })
        this.setState({items: response.results, cidades: cidades.sort(), estados: estados.sort()});
      }
    }

    fetchData();
  }

  selectUf = (e) => {
    this.setState({selectedUF: e.target.value});
  }

  selectCity = (e) => {
    this.setState({selectedCity: e.target.value});
  }

  render = () => {
    const { language } = this.context;
    let home = ''
    let ondeEncontrar = ''
    switch (language) {
      case 'pt-br':
        home = 'Inicio';
        ondeEncontrar = 'Onde encontrar';
        break;
      case 'en-us':
        home = 'Home';
        ondeEncontrar = 'Where to find';
        break;
      case 'es-es':
        home = 'Inicio';
        ondeEncontrar = 'Donde encontrar';
        break;
      default:
    }   
    const {seo, items, cidades, estados, selectedUF, selectedCity } = this.state;
    return (
      <div id="home">
        <MetaTags>
          <title>{ seo.meta_title }</title>
          <meta id="meta-description" name="description" content={ seo.meta_description } />
          <meta id="og-title" property="og:title" content={ seo.meta_title } />
        </MetaTags>
        <Header />
        <Breadcrumbs title={ ondeEncontrar }>
          <div>
            <Link to="/">{ home }</Link>
            <span>{ ondeEncontrar }</span>
          </div>
        </Breadcrumbs>
        <BarWhereFind active="representantes" />
        <Container>
          <div className="wrapper">
            <Title>
              Selecione seu estado e cidade 
            </Title>
            <Filter>
              <select onChange={ this.selectUf }>
                <option value="">Estado</option>
                {
                  estados && estados.map((item, index) => {
                    if (item && item.length > 0) {
                      return (
                        <option key={ index } value={ item }>{ item }</option>
                      )
                    }
                    return true;
                  })
                }
              </select>
              <select onChange={ this.selectCity }>
                <option value="">Cidade</option>
                {
                  cidades && cidades.map((item, index) => {
                    if (item && item.length > 0) {
                      return (
                        <option key={ index } value={ item }>{ item }</option>
                      )
                    }
                    return true;
                  })
                }
              </select>
            </Filter>
            <Items>
              {
                items && items.map((item, index) => {
                  if (selectedUF.length > 0 && item.data.estado_uf !== selectedUF)
                    return (
                      <></>
                    )
                  if (selectedCity.length > 0 && item.data.cidade !== selectedCity)
                    return (
                      <></>
                    )
                  return (
                    <div className="item" key={ index }>
                      <strong className="title">{ item.data.title[0].text }</strong>
                      {
                        item.data.endereco && (
                          <p>
                            <strong>Endereço:</strong> { item.data.endereco }
                          </p>
                        )
                      }
                      {
                        item.data.cidade && (
                          <p>
                            <strong>Cidade:</strong> { item.data.cidade }
                          </p>
                        )
                      }
                      {
                        item.data.estado_uf && (
                          <p>
                            <strong>Estado:</strong> { item.data.estado_uf }
                          </p>
                        )
                      }
                      {
                        item.data.telefone && (
                          <p>
                            <strong>Telefone:</strong> { item.data.telefone }
                          </p>
                        )
                      }
                      {
                        item.data.celular && (
                          <p>
                            <strong>Celular:</strong> { item.data.celular }
                          </p>
                        )
                      }
                      {
                        item.data.email && (
                          <p>
                            <strong>Email:</strong> { item.data.email }
                          </p>
                        )
                      }
                    </div>
                  )
                })
              }
            </Items>
          </div>
        </Container>
        <Newsletter />
        <Footer />
      </div>
    );
  }
}

OndeEncontrarRepresentantes.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  location: PropTypes.object,
};

OndeEncontrarRepresentantes.contextType = LanguageContext;

export default OndeEncontrarRepresentantes;
